import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCardText, [_vm.deletePrompt ? _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('accMgmt.user.confirmDeleteUser'),
      "open": _vm.deletePrompt,
      "color": "red",
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'red',
        emit: 'delete'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": function ($event) {
        return _vm.doDeleteUser(_vm.deletionModel);
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.deletionModel.id) + "\n  ")]) : _vm._e(), _vm.apiKeyEditDialog ? _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.isOpen,
      "max-width": "900"
    },
    on: {
      "close": function ($event) {
        return _vm.close();
      }
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n      " + _vm._s(_vm.apiKeyModel.id ? _vm.$i18n_t('accMgmt.user.apiKey.edit') : _vm.$i18n_t('accMgmt.user.apiKey.create')) + "\n      "), _c(VRow, {
          staticClass: "px-0",
          attrs: {
            "no-gutters": "",
            "align": "center"
          }
        }, [_vm.apiKeyModel.id ? _c(VCol, {
          attrs: {
            "cols": "12",
            "sm": "12"
          }
        }, [_c('span', {
          staticClass: "monospace"
        }, [_vm._v(_vm._s(_vm.apiKeyModel.id.toUpperCase()))]), _c(VIcon, {
          staticClass: "ml-1",
          attrs: {
            "color": _vm.color,
            "size": "16"
          },
          on: {
            "click": function ($event) {
              return _vm.copyToClipboard(_vm.apiKeyModel.id);
            }
          }
        }, [_vm._v("fal fa-copy")])], 1) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save",
            "disabled": _vm.isCreatingApiKey || !_vm.editFormValidity
          },
          on: {
            "click": _vm.handleSubmit
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.save')) + "\n      ")])];
      },
      proxy: true
    }], null, false, 2386615496)
  }, [_c(VOverlay, {
    attrs: {
      "value": _vm.isCreatingApiKey
    }
  }, [_c(VProgressCircular, {
    attrs: {
      "color": _vm.color,
      "indeterminate": "",
      "width": "10",
      "size": "90",
      "rotate": "-90"
    }
  })], 1), _c(VOverlay, {
    attrs: {
      "value": _vm.loadAccessOverlay
    }
  }, [_c(VProgressCircular, {
    attrs: {
      "color": _vm.color,
      "indeterminate": "",
      "width": "8",
      "size": "90",
      "rotate": "-90"
    }
  })], 1), _c(VForm, {
    ref: "form",
    model: {
      value: _vm.editFormValidity,
      callback: function ($$v) {
        _vm.editFormValidity = $$v;
      },
      expression: "editFormValidity"
    }
  }, [_c(VRow, {
    staticClass: "mb-2",
    staticStyle: {
      "min-height": "0"
    }
  }, [_c(VCol, {
    staticClass: "px-3 py-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('accMgmt.user.apiKey.title'),
      "hide-details": "auto",
      "required": ""
    },
    model: {
      value: _vm.apiKeyModel.username,
      callback: function ($$v) {
        _vm.$set(_vm.apiKeyModel, "username", $$v);
      },
      expression: "apiKeyModel.username"
    }
  })], 1), _c(VCol, {
    staticClass: "px-3 py-1",
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "rules": _vm.requiredRule,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": `${_vm.$i18n_t('accMgmt.user.apiKey.limitLabel')}/${_vm.$i18n_t('accMgmt.user.apiKey.perMinute')}`,
      "hide-details": "auto",
      "type": "number",
      "required": ""
    },
    model: {
      value: _vm.apiKeyModel.properties.apiLimit,
      callback: function ($$v) {
        _vm.$set(_vm.apiKeyModel.properties, "apiLimit", $$v);
      },
      expression: "apiKeyModel.properties.apiLimit"
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-height": "0"
    }
  }, [_c(VCol, {
    staticClass: "px-3 py-1",
    attrs: {
      "cols": "12",
      "sm": "8"
    }
  }, [_c('core-dateTime-picker-flat', {
    attrs: {
      "from": new Date(_vm.apiKeyModel.properties.apiValidityDate) / 1000,
      "isRange": false,
      "futureRange": ""
    },
    on: {
      "date:picked": _vm.dateTimeChange
    }
  })], 1), _c(VCol, {
    staticClass: "px-3 py-1",
    attrs: {
      "cols": "12",
      "sm": "4"
    }
  }, [_c(VCheckbox, {
    attrs: {
      "label": _vm.$i18n_t('Common.active'),
      "color": _vm.color,
      "hide-details": "auto"
    },
    model: {
      value: _vm.apiKeyModel.active,
      callback: function ($$v) {
        _vm.$set(_vm.apiKeyModel, "active", $$v);
      },
      expression: "apiKeyModel.active"
    }
  })], 1)], 1), _c(VRow, {
    staticStyle: {
      "min-height": "0"
    }
  }, [!_vm.apiKeyModel.scope && !_vm.apiKeyModel.id ? _c(VCol, {
    staticClass: "px-3 pt-0 mt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c(VInput, {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "value": _vm.apiKeyModel.scope,
      "rules": _vm.requiredRule
    }
  }), _c('span', {
    staticClass: "px-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('accMgmt.user.selectedScope')))]), _vm.tenantDetails ? _c('core-tenant-scope-tree', {
    attrs: {
      "activeScopeId": _vm.tenantDetails.scopeId,
      "subject": "UserManagement",
      "action": "create"
    },
    on: {
      "update": _vm.didSelectScope
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.apiKeyModel.scope || _vm.apiKeyModel.id ? _c(VCol, {
    staticClass: "pt-0 mt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-tenant-scopes-permissions-list', {
    attrs: {
      "loading": !_vm.apiKeyModel.id && _vm.apiKeyModel.access.length === 0,
      "userAccess": _vm.apiKeyModel.access || []
    },
    on: {
      "updatedUserAccess": _vm.updatedUserAccess
    }
  })], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm.loading ? [_c(VSkeletonLoader, {
    attrs: {
      "type": "table-thead"
    }
  }), _c(VSkeletonLoader, {
    staticClass: "mx-2",
    attrs: {
      "type": "table-row-divider@5"
    }
  }), _c(VSkeletonLoader, {
    staticClass: "mx-auto",
    attrs: {
      "type": "table-tfoot"
    }
  })] : _c(VDataTable, {
    attrs: {
      "headers": _vm.tableLocalized.headers,
      "items": _vm.userList,
      "server-items-length": _vm.serverItemsLength,
      "expanded": _vm.expandedItems,
      "footer-props": _vm.tableFooterProps,
      "options": _vm.tableOptions,
      "item-key": "id",
      "page": _vm.tableOptions.page
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (props) {
        return [_c('tr', {
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('td', {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c('span', {
          ref: props.item.id,
          staticClass: "monospace"
        }, [_vm._v("\n            " + _vm._s(_vm.isApiKeysVisible ? props.item.id : props.item.id.toUpperCase().replace(/[0-9A-Z\-]/g, '•')) + "\n          ")]), _c(VIcon, {
          staticClass: "ml-2 mr-2",
          attrs: {
            "color": _vm.color,
            "size": "16"
          },
          on: {
            "click": function ($event) {
              return _vm.copyToClipboard(props.item.id);
            }
          }
        }, [_vm._v("\n            fal fa-copy\n          ")])], 1), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.clickedUserTableRow(props.item);
            }
          }
        }, [_vm._v(_vm._s(props.item.username))]), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.clickedUserTableRow(props.item);
            }
          }
        }, [_vm._v("\n          " + _vm._s(props.item.properties.apiLimit) + "/" + _vm._s(_vm.$i18n_t('accMgmt.user.apiKey.perMinute')) + "\n        ")]), _c('td', {
          on: {
            "click": function ($event) {
              return _vm.clickedUserTableRow(props.item);
            }
          }
        }, [_vm._v(_vm._s(_vm.localizeDate(props.item.properties.apiValidityDate)))]), _c('td', {
          staticClass: "text-center",
          on: {
            "click": function ($event) {
              return _vm.clickedUserTableRow(props.item);
            }
          }
        }, [props.item.active ? _c(VIcon, {
          attrs: {
            "color": _vm.color
          }
        }, [_vm._v("fal fa-check")]) : _vm._e(), !props.item.active ? _c(VIcon, {
          attrs: {
            "color": _vm.color
          }
        }, [_vm._v("fal fa-times")]) : _vm._e()], 1), _c('td', {
          staticClass: "text-right"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.edit'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.editApiKey(props.item);
            }
          }
        }, [_vm._v("\n            fal fa-edit\n          ")]), _c(VIcon, {
          staticClass: "ml-2",
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.deletionModel = props.item;
              _vm.deletePrompt = true;
            }
          }
        }, [_vm._v("\n            fal fa-trash-alt\n          ")])], 1)])];
      }
    }, {
      key: "expanded-item",
      fn: function (props) {
        return [_c('tr', [_c('td', {
          attrs: {
            "colspan": "6"
          }
        }, [_vm._l(_vm.accessesForUser(props.item), function (access, i) {
          return _c('div', {
            key: `user_${props.item.id}_access_${i}`
          }, [access && access.scopeId ? [_c('div', {
            class: `px-2 ${access.primary ? 'highlighted' : ''}`
          }, [_c('span', {
            staticStyle: {
              "display": "none"
            }
          }, [_vm._v(_vm._s(_vm.fetchScopeDetails(access.Scope)))]), _c('p', {
            staticClass: "text-overline pt-1 mb-0 grey--text"
          }, [_vm._v("\n                  " + _vm._s((_vm.scopeDetails[access.Scope.id] || {}).crumbPath) + "\n                ")]), _vm._v("\n                " + _vm._s((access.roles || []).map(r => r.name).join(', ')) + "\n              ")])] : _vm._e()], 2);
        }), _c('div', {
          staticClass: "mb-4"
        })], 2)])];
      }
    }, {
      key: "footer.page-text",
      fn: function (props) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n          " + _vm._s(props.pageStart) + " - " + _vm._s(props.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(props.itemsLength) + "\n        ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };